import { render, staticRenderFns } from "./ProductIntroChengTu.vue?vue&type=template&id=47986d74&scoped=true&"
import script from "./ProductIntroChengTu.vue?vue&type=script&lang=js&"
export * from "./ProductIntroChengTu.vue?vue&type=script&lang=js&"
import style0 from "./ProductIntroChengTu.vue?vue&type=style&index=0&id=47986d74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47986d74",
  null
  
)

export default component.exports